const n=()=>{if("undefined"==typeof window)return null;return"/"===window.location.pathname?"home":window.location.pathname};export{n as h};
